function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

window.openFullscreenVideo = (event) => {
  const videoWrapper = document.querySelector(`#${event.target.getAttribute('data-video-id')}`);

  const video = videoWrapper.querySelector("video");
  let wkFullscreen = false;
  let wkDesktopFullscreen = false;

  if (video.requestFullscreen) {
    video.requestFullscreen();
  } else if (video.mozRequestFullScreen) {
    video.mozRequestFullScreen();
  } else if (video.webkitRequestFullscreen) {
    video.webkitRequestFullscreen();
    wkDesktopFullscreen = true;
  } else if (video.msRequestFullscreen) {
    video.msRequestFullscreen();
  } else if (video.webkitEnterFullscreen) {
    wkFullscreen = true;
  }

  const ua = window.navigator.userAgent;
  const iPad = !!ua.match(/iPad/i);
  const webkit = !!ua.match(/WebKit/i);
  const iPadSafari = iPad && webkit && !ua.match(/CriOS/i);

  if (!wkFullscreen || iPadSafari) {
    video.muted = false;
    videoWrapper.classList.add('open');
    setTimeout(() => {
      video.addEventListener("fullscreenchange", (e) => {
        videoWrapper.classList.remove('open');
      }, { once: true });
      video.addEventListener("webkitfullscreenchange", (e) => {
        videoWrapper.classList.remove('open');
      }, { once: true });

      video.addEventListener("webkitendfullscreen", (e) => {
        videoWrapper.classList.remove('open');
      }, { once: true });
    }, 500);
  }

  if (wkFullscreen || wkDesktopFullscreen) {
    video.muted = false;
    video.play();
  }
}

window.openBackgroundVideo = (event) => {
  const videoWrapper = document.querySelector(`#${event.target.getAttribute('data-video-id')}`);
  const videoBlockContent = videoWrapper.closest(".video-banner")?.querySelector(".video-banner__content");
  const video = videoWrapper.querySelector("video");
  const videoClose = videoWrapper.querySelector(".video-close");
  videoClose.addEventListener('click', () => {
    videoWrapper.classList.remove("opened");
    if(videoBlockContent)
      videoBlockContent.classList.remove("hidden");
    video.pause();
  });

  videoWrapper.classList.add("opened");
  if(videoBlockContent)
    videoBlockContent.classList.add("hidden");
  let playPromise = video.play();
  if (playPromise !== undefined) {
    playPromise.then(_ => {
      video.play();
    })
      .catch(error => {
        console.log(error);
      });
  }
}

document.querySelectorAll('button[data-video-id^="video-fullscreen-"]').forEach((button) => {
  button.addEventListener('click', window.openFullscreenVideo);
});

document.querySelectorAll('button[data-video-id^="video-background-"]').forEach((button) => {
  button.addEventListener('click', window.openBackgroundVideo);
});

document.querySelectorAll('div[id^="video-fullscreen-"]').forEach((fullscreenVideoWrap) => {
  const closeBtn = fullscreenVideoWrap.querySelector('.video-close');
  closeBtn.addEventListener('click', (event) => {
    fullscreenVideoWrap.classList.remove('open');
    const fullscreenVideo = fullscreenVideoWrap.querySelector("video")
    fullscreenVideo.pause();
    fullscreenVideo.currentTime = 0;
  });
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.currency_symbol_position = this.input.dataset.currencySymbolPosition;
    this.changeEvent = new Event('change', { bubbles: true });
    this.priceWrap = document.querySelector("[data-price-wrap]");
    if (this.priceWrap)
      this.price = {
        regular: this.priceWrap.querySelector("[data-price-regular]"),
        sale: this.priceWrap.querySelector("[data-price-sale]"),
        compare: this.priceWrap.querySelector("[data-price-compare]")
      }
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  priceChange() {
    if (!this.priceWrap)
      return;
    if (this.price.regular) {
      this.price.regular.innerHTML = this.currency_symbol_position == 'true' ? this.priceWrap.dataset.currency + (this.input.value * this.price.regular.dataset.priceRegular / 100).toFixed(2) : (this.input.value * this.price.regular.dataset.priceRegular / 100).toFixed(2) + ' ' + this.priceWrap.dataset.currency;
    }
    if (this.price.sale) {
      this.price.sale.innerHTML = this.currency_symbol_position == 'true' ? this.priceWrap.dataset.currency + (this.input.value * this.price.sale.dataset.priceSale / 100).toFixed(2) : (this.input.value * this.price.sale.dataset.priceSale / 100).toFixed(2) + ' ' + this.priceWrap.dataset.currency;
    }
    if (this.price.compare) {
      this.price.compare.innerHTML = this.currency_symbol_position == 'true' ? this.priceWrap.dataset.currency + (this.input.value * this.price.compare.dataset.priceCompare / 100).toFixed(2) : (this.input.value * this.price.compare.dataset.priceCompare / 100).toFixed(2) + ' ' + this.priceWrap.dataset.currency;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.priceChange();
      this.input.dispatchEvent(this.changeEvent);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      if (!detailsElement.hasAttribute("no-menu-drawer"))
        setTimeout(() => {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', true);
          !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
      document.querySelector('.header-wrapper').removeAttribute('open-header');
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    const headerBlock = document.querySelector('.header-wrapper');
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    headerBlock.setAttribute('open-header', '');
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.isScaledType = this.slider.classList.contains('scaled-items');
    this.sliderItems = this.querySelectorAll('li.slider__slide:not(.dot):not(.slider__thumbnails__slide)');

    if (this.sliderItems.length === 0) {
      this.classList.add("hidden")
      this.lookForNewItems();
    }

    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.dotButtons = this.querySelectorAll('li.dot');
    this.thumbnailButtons = this.querySelectorAll('li.slider__thumbnails__slide');
    this.thumbnailButtonsWrapper = this.querySelector('.slider__thumbnails');

    if (!this.slider || (!this.nextButton && !this.dotButtons.length && !this.thumbnailButtons.length)) return;

    if (this.nextButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    if (this.dotButtons.length) {
      this.dotButtons.forEach(dotButton => {
        dotButton.addEventListener('click', this.onButtonClick.bind(this));
      });
    }

    if (this.thumbnailButtons.length) {
      this.thumbnailButtons.forEach(thumbnailButton => {
        thumbnailButton.addEventListener('click', this.onButtonClick.bind(this));
      });
    }

    document.addEventListener('DOMContentLoaded', (event) => {
      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);
      this.slider.addEventListener('scroll', this.update.bind(this));
    });
  }

  // Look for new items added to slider dynamically
  lookForNewItems() {
    document.addEventListener('DOMContentLoaded', (event) => {
      const sliderItemsMutationObserver = new MutationObserver((mutationsList, observer) => {
        this.sliderItems = this.querySelectorAll('li.slider__slide:not(.dot):not(.slider__thumbnails__slide)');
        if (this.sliderItems.length > 0) {
          this.classList.remove("hidden");
          observer.disconnect();
        }
      });
      sliderItemsMutationObserver.observe(this.slider, { attributes: false, childList: true, subtree: false });
    });
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    this.sliderFirstItem = sliderItemsToShow[0];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.round(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    if (this.isScaledType) {
      this.totalPages = sliderItemsToShow.length;
      this.nextButton.click();
    }
    this.update();
    this.style.opacity = "1";
  }

  updateSliderContent() {
    this.sliderItems = this.querySelectorAll('li.slider__slide:not(.dot):not(.slider__thumbnails__slide)');
    this.dotButtons = this.querySelectorAll('li.dot');
    if (this.dotButtons.length) {
      this.dotButtons.forEach(dotButton => {
        dotButton.addEventListener('click', this.onButtonClick.bind(this));
      });
    }
    this.initPages();
  }

  update() {
    let itemMargin = (this.isScaledType ? 0 : parseInt(window.getComputedStyle(this.sliderFirstItem, null).getPropertyValue('margin-left').split("px")[0]))
      + parseInt(window.getComputedStyle(this.sliderFirstItem, null).getPropertyValue('margin-right').split("px")[0]);
    this.thumbnailButtons = this.querySelectorAll('li.slider__thumbnails__slide');
    this.currentPage = Math.round(this.slider.scrollLeft / (this.sliderLastItem.clientWidth + itemMargin)) + 1;
    this.updateSliderButtons(this.currentPage);
    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }
    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    if (!this.pageCount || !this.pageTotal) return;
    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  updateSliderButtons(currentPage) {
    currentPage--;
    for (const sliderButtons of ["dotButtons", "thumbnailButtons"]) {
      this[sliderButtons].forEach((button, btnIndex) => {
        if (btnIndex !== currentPage && button.classList.contains('is-selected'))
          button.classList.remove('is-selected');
        else if (btnIndex === currentPage && !button.classList.contains('is-selected')) {
          button.classList.add('is-selected');
          if (sliderButtons === "thumbnailButtons") {
            this.thumbnailButtonsWrapper.scrollTo({
              left: button.offsetLeft,
              behavior: "smooth"
            });
          }
        }
      });
    }
    this.sliderItems.forEach((item, index) => {
      if (index !== currentPage && item.classList.contains('active'))
        item.classList.remove('active');
      else if (index === currentPage && !item.classList.contains('active')) {
        item.classList.add('active');
      }
    });
    if (this.callbackChangePosition) {
      this.callbackChangePosition(currentPage);
    }
  }

  scrollToPosition(index) {
    const scrollWidth = this.sliderFirstItem.clientWidth
      + parseInt(window.getComputedStyle(this.sliderFirstItem, null).getPropertyValue('margin-right').split("px")[0])
      + (this.isScaledType ? 0 : parseInt(window.getComputedStyle(this.sliderFirstItem, null).getPropertyValue('margin-left').split("px")[0]));

    let slideScrollPosition = scrollWidth * index;

    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    let slideScrollPosition = 0;
    const sliderType = event.currentTarget.classList.contains('dot') ? "dotButtons" : event.currentTarget.classList.contains('slider__thumbnails__slide') ? "thumbnailButtons" : null;
    // const scrollWidth = this.sliderLastItem.clientWidth + parseInt(window.getComputedStyle(this.sliderLastItem, null).getPropertyValue('padding-left').split("px")[0]);
    const scrollWidth = this.sliderFirstItem.clientWidth
      + parseInt(window.getComputedStyle(this.sliderFirstItem, null).getPropertyValue('margin-right').split("px")[0])
      + (this.isScaledType ? 0 : parseInt(window.getComputedStyle(this.sliderFirstItem, null).getPropertyValue('margin-left').split("px")[0]));

    if (sliderType) {
      const targetPageIndex = Array.from(this[sliderType]).indexOf(event.currentTarget);
      slideScrollPosition = scrollWidth * targetPageIndex;
    } else {
      slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + scrollWidth : this.slider.scrollLeft - scrollWidth;
    }
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateGlobalInfo();
    }
  }

  updateGlobalInfo() {
    if (Shopify.productInfo && this.currentVariant) {
      Shopify.productInfo['item_variant'] = this.currentVariant.sku;
      Shopify.productInfo['price'] = this.currentVariant.price / 100;
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const mediaSelector = `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`;
    const thumbnailSelector = `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}-thumbnail"]`;

    for (const [selectorIndex, selector] of [mediaSelector, thumbnailSelector].entries()) {
      const newMedia = document.querySelector(selector);
      if (!newMedia) continue;
      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
      const parent = newMedia.parentElement;
      if (parent.firstChild == newMedia) continue;
      if (selectorIndex === 0) {
        modalContent.prepend(newMediaModal);
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if(this.stickyHeader) {
          this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
        }
      }
      parent.prepend(newMedia);
      window.setTimeout(() => {
        parent.scrollLeft = 0;
        parent.querySelector(selectorIndex === 0 ? 'li.product__media-item' : 'li.slider__thumbnails__slide');
      });
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        for (const id of [`price-${this.dataset.section}`, `price-secondary-${this.dataset.section}`, `variant-savings-${this.dataset.section}`, `rc_price_onetime`, `rc_price_autodeliver`, 'klaviyo__preorder-btn', 'product-form__quantity-input__wrapper']) {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(id);
          const source = html.getElementById(id);

          if (source && destination) destination.innerHTML = source.innerHTML

          const price = document.getElementById(id)

          if (price) price.classList.remove('visibility-hidden')
        }
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class VariantRecommendations extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.values = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
    const recommendTooltipsAll = document.querySelectorAll(`.product-form_input_tooltip`);
    recommendTooltipsAll.forEach(tooltip => {
      tooltip.classList.remove('active');
    });

    for (const value of this.values) {
      const options = value.split(":");
      for (const optionValue of options) {
        const recommendLabels = document.querySelectorAll(`label[data-option-value="${optionValue}"]`);
        recommendLabels.forEach(label => {
          label.click();
          const tooltip = label.querySelector('.product-form_input_tooltip');
          tooltip.classList.add('active');
        })
      }
    }
  }
}

customElements.define('variant-recommendations', VariantRecommendations);


class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');

    this.setVideoSrc();
    this.playButton = this.querySelector(".video-play-pause");
    if (this.playButton)
      this.playButton.addEventListener("click", this.videoPlayPause.bind(this));

    if (this.video.getAttribute('autoplay') === null) {
      document.addEventListener('click', (event) => {
        let isClickInside = event.target === this || this.contains(event.target);
        if (!isClickInside) {
          if (this.video.paused !== true) {
            this.video.pause();
            this.video.currentTime = 0;
          }
        }
      });
    }

    this.video.addEventListener('pause', (event) => {
      if (this.playButton)
        this.playButton.classList.add("paused");
      this.classList.remove("playing");
    });
    this.video.addEventListener('play', (event) => {
      if (this.playButton)
        this.playButton.classList.remove("paused");
      this.classList.add("playing");
    });

    if (this.dataset.fullscreen) {
      this.setFullscreenPlayPause();
    }

    let lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

    if ("IntersectionObserver" in window) {
      let lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (video) {
          if (video.isIntersecting) {
            for (let source in video.target.children) {
              let videoSource = video.target.children[source];
              if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                videoSource.src = videoSource.dataset.src;
              }
            }

            video.target.load();
            video.target.classList.remove("lazy");
            lazyVideoObserver.unobserve(video.target);
          }
        });
      });

      lazyVideos.forEach(function (lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
      });
    }
  }

  setFullscreenPlayPause() {
    this.video.muted = true;
    let playPromise = this.video.play();
    if (playPromise !== undefined) {
      playPromise.then((_) => {
        let observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (
                !entry.isIntersecting &&
                !this.video.paused
              ) {
                this.video.pause();
                this.video.muted = true;
              } else if (this.video.paused && entry.isIntersecting) {
                this.video.muted = false;
                this.video.play();
              }
            });
          },
          { threshold: 0.2 }
        );
        observer.observe(this.video);
      });
    }
  }

  setVideoSrc() {
    const screenWidth = this.getScreenWidth();
    let videoSize = "small";
    if (screenWidth > 1200) {
      videoSize = "wide";
    } else if (screenWidth > 960) {
      videoSize = "medium";
    }
    let videoSrc = this.video.getAttribute(`data-src-${videoSize}`);
    if (!videoSrc || videoSrc === '')
      videoSrc = this.video.getAttribute(`data-src`);
    if (videoSrc && videoSrc !== '') {
      if(this.video.classList.contains('lazy')){
        this.video.innerHTML = `<source type="video/mp4" data-src="${videoSrc}" />` + this.video.innerHTML;
      } else {
        this.video.innerHTML = `<source type="video/mp4" src="${videoSrc}" />` + this.video.innerHTML;
      }
    }
  }

  getScreenWidth() {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );
  }

  videoPlayPause() {
    let videoSource = this.video.querySelector("source");
    if (!videoSource)
      this.setVideoSrc();
    if (this.video.paused === true) {
      this.video.play();
    } else {
      this.video.pause();
    }
  }
}

customElements.define('video-component', VideoComponent);

class DataTable extends HTMLElement {
  constructor() {
    super();
    this.config = {};
    this.config.columnOrder = this.dataset.tablecolumnorder.split(",");
    this.initTable();
    this.loadEasepick(this.init.bind(this));
  }

  initTable() {
    this.innerHTML = `
      <div class="data-table__head">
        <div class="data-table__head__info">
          ${this.dataset.tablename ? '<h3>' + this.dataset.tablename + '</h3>' : ''}
          ${this.dataset.counterlabel ? '<span><span data-id="counter">0</span> ' + this.dataset.counterlabel + '</span>' : ''}
        </div>
        <input name="date" />
      </div>
      <div class="customer-petz__table">
        <table role="table" class="data-table--margin">
          ${this.dataset.tablecaption ? '<caption class="visually-hidden">' + this.dataset.tablecaption + '</caption>' : ''}
          <thead role="rowgroup">
            <tr role="row" class="color-vetz-petz-reverse"></tr>
          </thead>
          <tbody role="rowgroup">
            <tr role="row" class="line-break">
            </tr>
          </tbody>
        </table>
      </div>
    `;

    this.table = this.querySelector("table");
    this.tbody = this.table.querySelector("tbody");

    const thead_tr = this.table.querySelector("thead tr");
    const tbody_tr = this.tbody.querySelector("tr");

    for (const column of this.config.columnOrder) {
      thead_tr.innerHTML += `<th id="Column_${column}" scope="col" role="columnheader">${this.dataset["column_" + column]}</th>`;
      tbody_tr.innerHTML += `<td headers="RowOrder Column_${column}" role="cell" data-label="${this.dataset["column_" + column]}" data-field="${column}"></td>`
    }

    this.rowSample = this.tbody.querySelector("tr");
    this.rowSample.parentElement.removeChild(this.rowSample);
    this.datePickerSelect = this.querySelector("input[name=date]");
    this.counter = this.querySelector("span[data-id=counter]");
  }

  init() {
    let paramString = "";
    for (const [key, value] of Object.entries(this.dataset)) {
      if (key.includes("urlparam_")) {
        paramString += `${paramString.length > 0 ? "&" : ""}${key.split("urlparam_")[1]}=${value}`;
      }
    }
    this.config.urlParamString = paramString;
    this.initDatePicker();
    this.fetchData(this.datePicker.getStartDate(), this.datePicker.getEndDate()).then(data => this.populateData(data));
  }

  loadEasepick(implementationCode) {
    let scriptTag = document.querySelector('script#easepick');
    const scriptTagExists = scriptTag;
    if (!scriptTagExists) {
      scriptTag = document.createElement('script');
      scriptTag.src = "https://cdn.jsdelivr.net/npm/@easepick/bundle@1.0.0/dist/index.umd.min.js";
    }

    if (typeof easepick === 'undefined') {
      scriptTag.onload = implementationCode;
      scriptTag.onreadystatechange = implementationCode;
    }

    if (!scriptTagExists)
      document.head.appendChild(scriptTag);
  }

  initDatePicker() {
    this.datePicker = new easepick.create({
      element: this.datePickerSelect,
      css: [
        'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.0.0/dist/index.css'
      ],
      plugins: ['RangePlugin'],
      RangePlugin: {
        tooltipNumber(num) {
          return num - 1;
        }
      },
      format: "DD/MM/YYYY",
      setup: this.setupDatePicker.bind(this)
    });
    const start = new Date();
    const end = new Date();
    const firstDayOfMonth = new Date(start.getFullYear(), start.getMonth(), 1);

    this.datePicker.setStartDate(firstDayOfMonth);
    this.datePicker.setEndDate(end);
  }

  setupDatePicker(datePicker) {
    datePicker.on('select', (e) => {
      const { start, end } = e.detail;
      this.fetchData(start, end).then(data => this.populateData(data));
    });
  }

  fetchData(start, end) {
    end.setHours(23, 59, 59, 999);
    return fetch(`${this.dataset.url}?${this.config.urlParamString}${this.config.urlParamString.length > 0 ? "&" : ""}from=${~~(start.getTime() / 1000)}&to=${~~(end.getTime() / 1000)}`)
    .then(response => response.json());
  }

  populateData(data) {
    const responseData = data && data.affiliates && data.affiliates[0] && data.affiliates[0][this.dataset.responsedatafield] ? data.affiliates[0][this.dataset.responsedatafield] : null;
    this.tbody.innerHTML = "";
    if (responseData?.length > 0) {
      if (this.counter)
        this.counter.innerHTML = responseData.length;
      for (const record of responseData) {
        const row = this.rowSample.cloneNode(true);
        const cells = row.querySelectorAll("td");
        for (const cell of cells) {
          if (["created"].includes(cell.dataset.field)) {
            const date = new Date(parseInt(record[cell.dataset.field] + "000"));
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            cell.innerHTML = `${day}/${month}/${year}`;
          } else if (["product_names"].includes(cell.dataset.field)) {
            cell.innerHTML = record[cell.dataset.field].join("<br>");
          } else if (["customer_email"].includes(cell.dataset.field)) {
            cell.innerHTML = record[cell.dataset.field].substring(0, 4);
          } else {
            cell.innerHTML = record[cell.dataset.field];
          }
        }
        this.tbody.appendChild(row);
      }
    } else {
      const row = this.rowSample.cloneNode(true);
      const cells = row.querySelectorAll("td");
      for (const [index, cell] of cells.entries()) {
        if (index > 0) {
          row.removeChild(cell);
        } else {
          cell.setAttribute("colspan", this.config.columnOrder.length);
          cell.innerHTML = this.dataset.noDataLabel ? this.dataset.noDataLabel : "No data for the selected period";
        }
      }
      this.tbody.appendChild(row);
    }
  }
}

customElements.define('data-table', DataTable);

class AffiliateProgressBar extends HTMLElement {
  constructor() {
    super();
    this.config = {};
    this.init();
  }

  init() {
    let paramString = "";
    for (const [key, value] of Object.entries(this.dataset)) {
      if (key.includes("urlparam_")) {
        paramString += `${paramString.length > 0 ? "&" : ""}${key.split("urlparam_")[1]}=${value}`;
      }
    }
    this.config.urlParamString = paramString;
    this.config.monthUrlParamString = `action=${this.dataset.monthparam_action}&email=${this.dataset.urlparam_email}`;
    this.createCommissionTotal();
    this.createOrderTotal();
    this.createCustomerTotal();
    this.fetchData().then(data => this.populateData(data));
    this.fetchMonthData().then(data => this.populateMonthData(data));
  }

  calcProgressColor(size, index) {
    return 0.3 + (0.7 / size) * index;
  }

  createCommissionTotal() {
    this.commissionTotal = this.querySelector("[data-commission-total]");
    this.commissionTotalSettings = {
      steps: this.commissionTotal.dataset.steps.split(","),
      labelsContainer: this.commissionTotal.querySelector("[data-progress-labels]"),
      barContainer: this.commissionTotal.querySelector("[data-progress-bar]"),
      valueContainer: this.commissionTotal.querySelector("[data-value]"),
      ranges: []
    };

    this.commissionTotalSettings.steps.forEach((step) => {
      this.commissionTotalSettings.labelsContainer.innerHTML += `<div><span>${step}</span></div>`;
    });

    this.commissionTotalSettings.labelsContainer.style.setProperty('--num-divisions', this.commissionTotalSettings.steps.length - 1);

    for (let index = 1; index < this.commissionTotalSettings.steps.length; index++) {
      let colorFillStart = this.calcProgressColor(this.commissionTotalSettings.steps.length, index); // 0.3 + (0.7 / this.commissionTotalSettings.steps.length) * index;
      let colorFillEnd = this.calcProgressColor(this.commissionTotalSettings.steps.length, index + 1); // 0.3 + (0.7 / this.commissionTotalSettings.steps.length) * (index + 1);

      this.commissionTotalSettings.barContainer.innerHTML += `
        <div class="progress-bar">
          <div class="progress-fill" id="commissionTotalBar${index}"
            style="background: linear-gradient(to right, rgba(var(--color-fill), ${colorFillStart}), rgba(var(--color-fill), ${colorFillEnd}));"
          ></div>
        </div>
      `;
      this.commissionTotalSettings.ranges.push({
        min: parseInt(this.commissionTotalSettings.steps[index - 1].replace('$', '')),
        max: parseInt(this.commissionTotalSettings.steps[index].replace('$', '')),
        fill: `#commissionTotalBar${index}`
      });
    }
  }

  populateCommissionTotal(commissionTotal) {
    this.commissionTotalSettings.valueContainer.innerHTML = this.dataset.currencySymbol + commissionTotal;

    // Update each progress bar based on conversion value
    this.commissionTotalSettings.ranges.forEach(range => {
      let progressFill = this.querySelector(range.fill);

      if (commissionTotal >= range.max) {
        progressFill.style.width = '100%';
      } else if (commissionTotal >= range.min) {
        let percentage = ((commissionTotal - range.min) / (range.max - range.min)) * 100;
        progressFill.style.width = percentage + '%';
      } else {
        progressFill.style.width = '0%';
      }
    });
  }

  createOrderTotal () {
    this.orderTotal = this.querySelector("[data-order-total]");
    this.orderTotalSettings = {
      steps: this.orderTotal.dataset.steps.split(","),
      labelsContainer: this.orderTotal.querySelector("[data-progress-labels]"),
      barContainer: this.orderTotal.querySelector("[data-progress-bar]"),
      valueContainer: this.orderTotal.querySelector("[data-value]"),
      ranges: []
    };

    this.orderTotalSettings.steps.forEach((step) => {
      this.orderTotalSettings.labelsContainer.innerHTML += `<div><span>${step}</span></div>`;
    });

    this.orderTotalSettings.labelsContainer.style.setProperty('--num-divisions', this.orderTotalSettings.steps.length - 1);

    for (let index = 1; index < this.orderTotalSettings.steps.length; index++) {
      let colorFillStart = this.calcProgressColor(this.orderTotalSettings.steps.length, index); // 0.3 + (0.7 / this.orderTotalSettings.steps.length) * index;
      let colorFillEnd = this.calcProgressColor(this.orderTotalSettings.steps.length, index + 1); // 0.3 + (0.7 / this.orderTotalSettings.steps.length) * (index + 1);

      this.orderTotalSettings.barContainer.innerHTML += `
        <div class="progress-bar">
          <div class="progress-fill" id="orderTotalBar${index}"
            style="background: linear-gradient(to right, rgba(var(--color-fill), ${colorFillStart}), rgba(var(--color-fill), ${colorFillEnd}));"
          ></div>
        </div>
      `;
      this.orderTotalSettings.ranges.push({
        min: parseInt(this.orderTotalSettings.steps[index - 1]),
        max: parseInt(this.orderTotalSettings.steps[index]),
        fill: `#orderTotalBar${index}`
      });
    }
  }

  populateOrderTotal (orderTotal) {
    this.orderTotalSettings.valueContainer.innerHTML = orderTotal;

    // Update each progress bar based on conversion value
    this.orderTotalSettings.ranges.forEach(range => {
      let progressFill = this.querySelector(range.fill);

      if (orderTotal >= range.max) {
        progressFill.style.width = '100%';
      } else if (orderTotal >= range.min) {
        let percentage = ((orderTotal - range.min) / (range.max - range.min)) * 100;
        progressFill.style.width = percentage + '%';
      } else {
        progressFill.style.width = '0%';
      }
    });
  }

  createCustomerTotal () {
    this.customerTotal = this.querySelector("[data-customer-total]");
    this.customerTotalSettings = {
      steps: this.customerTotal.dataset.steps.split(","),
      labelsContainer: this.customerTotal.querySelector("[data-progress-labels]"),
      barContainer: this.customerTotal.querySelector("[data-progress-bar]"),
      valueContainer: this.customerTotal.querySelector("[data-value]"),
      ranges: []
    };

    this.customerTotalSettings.steps.forEach((step) => {
      this.customerTotalSettings.labelsContainer.innerHTML += `<div><span>${step}</span></div>`;
    });

    this.customerTotalSettings.labelsContainer.style.setProperty('--num-divisions', this.customerTotalSettings.steps.length - 1);

    for (let index = 1; index < this.customerTotalSettings.steps.length; index++) {
      let colorFillStart = this.calcProgressColor(this.customerTotalSettings.steps.length, index); // 0.3 + (0.7 / this.customerTotalSettings.steps.length) * index;
      let colorFillEnd = this.calcProgressColor(this.customerTotalSettings.steps.length, index + 1); // 0.3 + (0.7 / this.customerTotalSettings.steps.length) * (index + 1);

      this.customerTotalSettings.barContainer.innerHTML += `
        <div class="progress-bar">
          <div class="progress-fill" id="customerTotalBar${index}"
            style="background: linear-gradient(to right, rgba(var(--color-fill), ${colorFillStart}), rgba(var(--color-fill), ${colorFillEnd}));"
          ></div>
        </div>
      `;
      this.customerTotalSettings.ranges.push({
        min: parseInt(this.customerTotalSettings.steps[index - 1]),
        max: parseInt(this.customerTotalSettings.steps[index]),
        fill: `#customerTotalBar${index}`
      });
    }
  }

  populateCustomerTotal (customerTotal) {
    this.customerTotalSettings.valueContainer.innerHTML = customerTotal;

    // Update each progress bar based on conversion value
    this.customerTotalSettings.ranges.forEach(range => {
      let progressFill = this.querySelector(range.fill);

      if (customerTotal >= range.max) {
        progressFill.style.width = '100%';
      } else if (customerTotal >= range.min) {
        let percentage = ((customerTotal - range.min) / (range.max - range.min)) * 100;
        progressFill.style.width = percentage + '%';
      } else {
        progressFill.style.width = '0%';
      }
    });
  }

  fetchData() {
    return fetch(`${this.dataset.url}?${this.config.urlParamString}`)
    .then(response => response.json());
  }

  populateData(data) {
    const conversions = data.affiliates?.[0]?.conversions ?? [];
    const commissionTotalSum = conversions.reduce((sum, conversion) => sum + parseFloat(conversion.commission_total), 0.0);
    const emailSet = new Set();
    conversions.forEach(conversion => {
      if (conversion.customer_email !== "") {
        emailSet.add(conversion.customer_email);
      }
    });

    this.populateCommissionTotal(commissionTotalSum.toFixed(2));
    this.populateOrderTotal(conversions.length);
    this.populateCustomerTotal(emailSet.size);
  }

  fetchMonthData() {
    const now = new Date();
    // Get the start of the current month
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    // Convert to Unix timestamps (seconds since epoch)
    const fromTimestamp = Math.floor(startOfMonth.getTime() / 1000);
    const toTimestamp = Math.floor(now.getTime() / 1000);

    return fetch(`${this.dataset.url}?${this.config.monthUrlParamString}${this.config.urlParamString.length > 0 ? "&" : ""}from=${fromTimestamp}&to=${toTimestamp}`)
    .then(response => response.json());
  }

  populateMonthData(data) {
    const conversions = data.affiliates?.[0]?.conversions ?? [];
    const emailSet = new Set();
    conversions.forEach(conversion => {
      if (conversion.customer_email !== "") {
        emailSet.add(conversion.customer_email);
      }
    });

    const emailCountMap = {};
    // Count occurrences of each customer_email
    conversions.forEach(conversion => {
      if (conversion.customer_email !== "") {
        const email = conversion.customer_email;
        if (emailCountMap[email]) {
          emailCountMap[email]++;
        } else {
          emailCountMap[email] = 1;
        }
      }
    });

    let uniqueCount = 0;
    let duplicateCount = 0;

    Object.keys(emailCountMap).forEach(email => {
        if (emailCountMap[email] === 1) {
            uniqueCount++;
        } else if (emailCountMap[email] > 1) {
            duplicateCount++;
        }
    });

    const pendingOrders = conversions.filter(conversion => conversion.status === "PENDING");
    const totalCommission = pendingOrders.reduce((sum, conversion) => sum + parseFloat(conversion.commission_total), 0);

    this.querySelector("[data-month_pending]").innerHTML = this.dataset.currencySymbol + totalCommission.toFixed(2);
    this.querySelector("[data-month_orders]").innerHTML = conversions.length;
    this.querySelector("[data-month_customers]").innerHTML = emailSet.size;
    this.querySelector("[data-month_first_time]").innerHTML = uniqueCount;
    this.querySelector("[data-month_returning]").innerHTML = duplicateCount;
  }
}

customElements.define('affiliate-progress-bar', AffiliateProgressBar);

class PopupModal extends HTMLElement {
  constructor() {
    super();
    const openBtn = document.querySelector(`[data-popup-modal-id=${this.id}]`);
    const closeBtn = this.querySelector(`a[name=close]`);
    this.onBodyClick = this.handleBodyClick.bind(this);
    openBtn.addEventListener("click", () => {
      this.classList.add("opened");
      setTimeout(() => {
        document.body.addEventListener('click', this.onBodyClick);
      }, 500);
    });
    closeBtn.addEventListener("click", this.onBodyClick);
    this.onBodyClick = this.handleBodyClick.bind(this);
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if ((!target.closest('.popup-modal__content') && !target.classList.contains("cf-remove")) || target.classList.contains("close")) {
      this.close();
      document.body.removeEventListener('click', this.onBodyClick);
    }
  }

  close() {
    this.classList.remove("opened");
  }
}

customElements.define('popup-modal', PopupModal);

class VetsCalculator extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.annualPrice = this.querySelector("#margin-section-annual-price");
    this.monthlyPrice = this.querySelector("#margin-section-monthly-price");
    this.patientsCount = this.querySelector("#margin-section-patients-count");

    this.config = {
      caps30: parseInt(this.dataset["caps-30"]),
      caps60: parseInt(this.dataset["caps-60"]),
      duration: parseInt(this.dataset["duration"]),
      commission: parseInt(this.dataset["commission"]),
      pets: {}
    };

    this.pets = this.querySelectorAll(".vets-calculator__pet");
    this.pets.forEach(pet => {
      const petName = pet.dataset["name"];
      this.config.pets[petName] = {
        caps: pet.dataset["caps"],
        value: pet.querySelector("input[type=number]"),
        range: pet.querySelector("input[type=range]"),
        split: parseInt(pet.dataset["split"]),
      };

      this.config.pets[petName]["range"].addEventListener('input', input => {
        if (this.config.pets[petName]["value"].value !== input.target.value) {
          this.config.pets[petName]["value"].value = input.target.value;
          this.config.pets[petName]["value"].dispatchEvent(new Event('input'));
          return;
        }
        this.changeResults(this.calculateFormula());
      });

      this.config.pets[petName]["value"].addEventListener('input', input => {
        if (this.config.pets[petName]["range"].value !== input.target.value) {
          this.config.pets[petName]["range"].value = input.target.value;
          this.config.pets[petName]["range"].dispatchEvent(new Event('input'));
          return
        }
        this.changeResults(this.calculateFormula());
      });

      this.config.pets[petName]["range"].dispatchEvent(new Event('input'));
    });

  }

  changeResults([value, petCount]) {
    this.annualPrice.innerHTML = parseInt(value / 100).toLocaleString();
    this.monthlyPrice.innerHTML = parseInt(value / 1200).toLocaleString();
    this.patientsCount.innerHTML = petCount.toLocaleString();
  }

  calculateFormula () {
    let total = 0;
    let totalPets = 0;
    for (let pet in this.config.pets) {
      if (!this.config.pets.hasOwnProperty(pet))
        continue;
      const petInfo = this.config.pets[pet];
      const petCount = parseInt(petInfo["value"].value);
      const calc = petCount * (petInfo["split"] / 100) * this.config.duration * (this.config.commission / 100) * this.config[petInfo["caps"]];
      total += calc;
      totalPets += petCount;
    }
    return [total, totalPets];
  }
}

customElements.define('vets-calculator', VetsCalculator);

class AnimatedButton extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll(".svg-animation-path").forEach(pathElement => {
      const pathLength = pathElement.getBoundingClientRect().width * 1.7;
      pathElement.setAttribute('style', 'stroke-dasharray:'+pathLength+';stroke-dashoffset:'+pathLength);
    });
    const animatedButtons = this.querySelectorAll(".svg-animation");
    window.addEventListener("scroll", () => {
      animatedButtons.forEach(button => {
        const blockSettings = button.getBoundingClientRect();
        const stepBottom = blockSettings.top - window.innerHeight + blockSettings.height / 2;
        if (stepBottom < 0) {
          button.classList.add("animated");
        } else {
          button.classList.remove("animated");
        }
      });
    });
  }
}
customElements.define('animated-button', AnimatedButton);

class VideoPopup extends HTMLElement {
  constructor() {
    super();
    this.settings = {
      videos: this.querySelectorAll(".video-for-popup__video .video-play-pause"),
      popup: this.querySelector(".video__popup"),
      closePopup: this.querySelector(".video__popup .video__popup-close"),
      videoComponent: this.querySelector(".video__popup video-component"),
      video: this.querySelector(".video__popup video-component video")
    }
    this.settings.videos.forEach(video => {
      video.addEventListener("click", () => {
        document.body.style.overflow = "hidden";
        this.settings.popup.classList.add("active");
        this.settings.video.dataset.src = video.dataset.videoSrc;
        this.settings.videoComponent.setVideoSrc();
        this.settings.video.load();
      });
    });
    this.settings.closePopup.addEventListener("click", () => {
      document.body.style.overflow = "unset";
      this.settings.video.pause();
      this.settings.popup.classList.remove("active");
      this.settings.video.innerHTML = "";
    });
    this.settings.popup.addEventListener("click", (e) => {
      if (e.target !== this.settings.popup)
        return;
      document.body.style.overflow = "unset";
      this.settings.video.pause();
      this.settings.popup.classList.remove("active");
      this.settings.video.innerHTML = "";
    });
  }
}
customElements.define('video-popup', VideoPopup);

/*
  Add visible class on scrolling to the element.
  Applies to all elements with data-animate attribute
*/
window.addEventListener('load', function() {
  const intersectionObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible");
      }
    });
  }, {
    rootMargin: '0px',
    threshold: 0.5
  });

  document.querySelectorAll("[data-animate]").forEach((element) => {
    intersectionObserver.observe(element);
  })
});

/*
  Add/remove visible class on scrolling to the element.
  Applies to all elements with data-animation attribute
  data-animation="fadeInRight", data-animation="fadeInLeft"
*/
document.addEventListener('DOMContentLoaded', () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const animation = entry.target.getAttribute("data-animation");

      if (entry.isIntersecting) {
        entry.target.classList.add("animated", `${animation}`);
      } else {
        entry.target.classList.remove("animated", `${animation}`);
      }
    });
  }/*, {rootMargin: "10px"}*/);

  const animatedEls = document.querySelectorAll("[data-animation]");
  animatedEls.forEach((el) => observer.observe(el));
});
